import { wixImageToProGallery as wixImageToProGalleryBase, wixCodeItemToProGallery as wixCodeItemToProGalleryBase } from '@wix/pro-gallery-items-formatter';
export function wixImageToProGallery(wixImg) {
  return wixImageToProGalleryBase(wixImg);
}
export function wixCode3dItemToProGallery(wixItem, i) {
  const formattedAsVideo = wixCodeItemToProGalleryBase({
    ...wixItem,
    type: 'video'
  }, i);
  const dimension = {
    width: 300,
    height: 300
  };
  return {
    mediaUrl: wixItem.src,
    orderIndex: i,
    itemId: formattedAsVideo.itemId,
    metaData: {
      type: '3d',
      ...dimension,
      poster: {
        ...formattedAsVideo.metaData.posters[0],
        ...dimension
      },
      scene: {
        transform: {
          rotation: wixItem.rotation && `x${wixItem.rotation.x}y${wixItem.rotation.y}z${wixItem.rotation.z}`,
          scale: wixItem.scale && `x${wixItem.scale.x}y${wixItem.scale.y}z${wixItem.scale.z}`,
          position: wixItem.position && `x${wixItem.position.x}y${wixItem.position.y}z${wixItem.position.z}`
        },
        controls: {
          enableAutoRotate: wixItem.enableAutoRotate,
          enablePan: wixItem.enablePan,
          enableRotate: wixItem.enableRotate,
          enableZoom: wixItem.enableZoom
        }
      },
      title: wixItem.title,
      description: wixItem.description,
      alt: wixItem.alt
    }
  };
}
export const wixCodeItemsToProGallery = wixCodeItems => {
  try {
    return wixCodeItems.map((wixCodeItem, i) => {
      if (wixCodeItem.type === '3d') {
        return wixCode3dItemToProGallery(wixCodeItem, i);
      }
      return wixCodeItemToProGalleryBase(wixCodeItem, i);
    }).map((item, i) => {
      const wixCodeItem = wixCodeItems[i];
      if (wixCodeItem.secondaryMedia && item.metaData.type !== 'video') {
        // no need to add type in the secondary media, should be derrived type from the main item.
        wixCodeItem.secondaryMedia.type = item.metaData.type;
        item.secondaryMedia = wixCodeItemToProGalleryBase(wixCodeItem.secondaryMedia, i);
      }
      return item;
    });
  } catch (e) {
    console.error('Wrong format for gallery items', wixCodeItems, e);
  }
  return [];
};
//# sourceMappingURL=format.js.map